module.exports = __webpack_public_path__ + "15_scivis.jpg?349fa08c20996f5bb07bb01773c37151";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/15_scivis.jpg
// module id = 158
// module chunks = 0